import { GTMPageCategory } from '../lib/types';

const mapPathnameToPageCategory: Record<GTMPageCategory, string[]> = {
  homepage: ['/'],
  'product selector page': ['/catalog', '/catalog/*', '/packs/*'],
  'product detail page': ['/product/*'],
  appendix: [
    '/info',
    '/info/*',
    '/legal',
    '/legal/*',
    '/help',
    '/help/*',
    '/where-to-buy'
  ],
  news: [
    '/about-skin',
    '/about-skin/articles',
    '/about-skin/articles/categories/*',
    '/about-skin/articles/topics/*',
    '/about-skin/news',
    '/about-skin/news/categories/*',
    '/about-skin/news/topics/*'
  ],
  actions: ['/actions', '/actions/*'],
  diagnostic: ['/survey', '/survey/*'],
  specialists: ['/specialists', '/specialists/*'],
  experts: [
    '/about-skin/videos',
    '/about-skin/videos/categories/*',
    '/about-skin/videos/topics/*'
  ],
  cart: ['/cart', '/cart/*'],
  checkout: ['/checkout', '/checkout/*'],
  'content page': ['/about', '/about/*', '/loyalty'],
  'content page::branding page': [
    '/esthederm',
    '/bioderma',
    '/etat_pur',
    '/esthederm/*',
    '/bioderma/*',
    '/etat_pur/*'
  ],
  'content page::article': [
    '/about-skin/articles/*',
    '/about-skin/news/*',
    '/about-skin/videos/*'
  ],
  'internal search': ['/search'],
  'my account': ['/account', '/account/*'],
  others: []
};

/**
 * Отдает категорию страницы по пути
 * Ищем самый длинный путь, который начинается с пути из маппинга
 * /path === /path/
 * /path/* === /path/...
 */
export const getPageCategory = (pathname: string): GTMPageCategory => {
  const normalize = (value: string) => {
    if (!value) return '/';
    const lower = value.toLowerCase();
    if (lower === '/') return '/';
    return lower.replace(/\/+$/, '');
  };

  const normalizedPathname = normalize(pathname);

  const matchPattern = (pattern: string): number | null => {
    const isWildcard = pattern.endsWith('/*');
    const base = normalize(isWildcard ? pattern.slice(0, -2) : pattern);

    if (isWildcard) {
      if (
        normalizedPathname === base ||
        normalizedPathname.startsWith(base + '/')
      ) {
        return base.length;
      }
      return null;
    }

    return normalizedPathname === base ? base.length : null;
  };

  let bestCategory: GTMPageCategory | null = null;
  let bestLength = -1;

  const entries = Object.entries(mapPathnameToPageCategory) as [
    GTMPageCategory,
    string[]
  ][];

  entries.forEach(([category, patterns]) => {
    if (!patterns.length) return;
    patterns.forEach((pattern) => {
      const matchLength = matchPattern(pattern);
      if (matchLength !== null && matchLength > bestLength) {
        bestLength = matchLength;
        bestCategory = category;
      }
    });
  });

  const result = bestCategory ?? 'others';

  return result;
};

// console.log('USE CASES');
// const checkUseCases = (pathname: string, extected: string) => {
//   const result = getPageCategory(pathname);
//   console.log(extected === result, pathname, extected, result);
// };
// checkUseCases('/', 'homepage');
// checkUseCases('/catalog', 'product selector page');
// checkUseCases('/catalog/face', 'product selector page');
// checkUseCases('/catalog/face/face/face', 'product selector page');
// checkUseCases('/product/123', 'product detail page');
// checkUseCases('/product/123/123/123/123', 'product detail page');
// checkUseCases('/product', 'product detail page');
// checkUseCases('/info', 'appendix');
// checkUseCases('/info/123', 'appendix');
// checkUseCases('/about-skin/news', 'news');
// checkUseCases('/about-skin/news/categories', 'news');
// checkUseCases('/about-skin/news/categories/123', 'news');
// checkUseCases('/about-skin/news/123/123', 'content page::article');
// checkUseCases('/esthederm', 'content page::branding page');
// checkUseCases('/unknown', 'others');
